import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoleListActions,
  SetEmployeeEditcallActions,
  setClientBranchActions,
  SetEmployeeRetrieveActions,
  setShiftListsActions,
  SetEmployeeActions,
  getEMployeeInquriyIDS,
  getClientEditActions,
  SetRole_id,
} from "../../../Redux/Slice";
import Select from "react-select";
import "../../../StyleSheet/MainComponent/Employee/EmployeeCreate.scss";

const EmployeeCreate = (props) => {
  const { EditId, currentPage, setShow, client_id } = props;

  ////-----EDIT----IDS-------------------
  useEffect(() => {
    console.log(state.ClientBranchIDs.EmployeeIDs, "EDITSSSSS");
  }, []);
  const [displayStatus, setDisplayStatus] = useState(false);
  const createnewEmp = {
    role: "",
    employee: "",
    shiftId: "",
    client_id: "",
  };
  const [role, setRole] = useState([]);
  const [data, setData] = useState(createnewEmp);
  const [multiselect, setMuliselect] = useState([]);
  const [roleError, setroleError] = useState();
  let [nameList, setOptions] = useState([]);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [empErr, setEmpErr] = useState("");
  const [RoleErrE, SetRoleEdiErr] = useState("");

  useEffect(() => {
    const payloads = {
      search: "",
      page_size: 20,
      page: 1,
      client:""
    };
    dispatch(getRoleListActions(payloads));

    setRole(state.rolelists.RoleList.role);
  }, []);
  ////----CLient branch-----IDs---Form slice
  useEffect(() => {
    console.log(state.ClientBranchIDs.ClientBranchID, "Client Branch Ids");
  }, []);
  //----EDit----Id
  useEffect(() => {
    if (state.ClientBranchIDs.EmployeeIDs != "") {
      console.log(EditId, "efsd");
      const payload = {
        EditId: state.ClientBranchIDs.EmployeeIDs,
      };
      dispatch(SetEmployeeRetrieveActions(payload));
      console.log(state.EmployeeRetrieve.EmployeeRetrieve, "statesd");
    }
  }, []);

  ///----------Clients-------------
  const [SelectedClient, setClientSel] = useState([]);
  const [Selectrole, setRoleSel] = useState([]);
  const [SelectedShift, setSleShf] = useState([]);
  useEffect(() => {
    const Datas = [];

    if (state.EmployeeRetrieve.EmployeeRetrieve.id != undefined) {
      console.log(state.EmployeeRetrieve.EmployeeRetrieve, "Retrievess");

      let objectArray1 = [];
      objectArray1.push({
        value: state.EmployeeRetrieve.EmployeeRetrieve.role_id.id,
        label: state.EmployeeRetrieve.EmployeeRetrieve.role_id.role,
      });
      setRoleSel(objectArray1);

      console.log(
        objectArray1,
        state.EmployeeRetrieve.EmployeeRetrieve.role_id,
        "opopop",
        data
      );
      console.log(data, "090909");
    }
  }, [state.EmployeeRetrieve.EmployeeRetrieve.id]);

  ////--_Edit---changes
  const [MuliEDit, setMuliselectEdit1] = useState([]);
  const [MuilEditROle, SetMuliEditrole] = useState([]);

  useEffect(() => {
    setRole(state.rolelists.RoleList.role);
    if (state.rolelists.RoleList != undefined) {
      let objectArray = [];
      state.rolelists.RoleList.forEach((element) => {
        objectArray.push({ value: element.id, label: element.role });
      });
      console.log(state.rolelists.RoleList, "roless", nameList);

      setOptions(objectArray);
    }
  }, [state.rolelists]);

  ///------ADDING MUITIPLE EMPLOYEES--------------------------------

  const [inputFields, setInputFields] = useState([
    {
      employee_request: "",
      role_id: "",
      client_id: state.ClientBranchIDs.ClientBranchID,
    },
  ]);

  const handleAddFields = () => {
    const values = [...inputFields];
    values.push({
      employee_request: "",
      role_id: "",
      client_id: state.ClientBranchIDs.ClientBranchID,
    });
    setInputFields(values);
  };

  const handleRemoveFields = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);
    setInputFields(values);
  };

  const handleInputChange = (index, event) => {
    const values = [...inputFields];
    if (event.target.name === "employee_request") {
      values[index].employee_request = event.target.value;
    }
    setInputFields(values);
  };
  const handleSelectChange = (selectedVal, index) => {
    setMuliselect(selectedVal);
    console.log(selectedVal, "zzcx", index);
    const values = [...inputFields];
    values[index].role_id = selectedVal.value;

    console.log(selectedVal.value, "selectedValues");
  };
  console.log(state.ClientBranchIDs.EmployeeIDs, "ipoipoipo");

  ///-------____Set ---the ---value to the Edit Funtionalities

  ///-----Emp-----EDITS------------------------
  const [IDs, setIds] = useState([{ role_id: "" }]);
  useEffect(() => {
    if (
      // state.ClientBranchIDs.EmployeeIDs != undefined &&
      !displayStatus
    ) {
      if (state.EmployeeRetrieve.EmployeeRetrieve.id != undefined) {
        setEmpEdit([
          {
            employee_request:
              state.EmployeeRetrieve.EmployeeRetrieve.employee_request,
            role_id: state.EmployeeRetrieve.EmployeeRetrieve.role_id.id,
            inquiry_id: state.ClientBranchIDs.EmployeeIDs,
          },
        ]);
        //dispatch(getEMployeeInquriyIDS(""));
        console.log(
          state.EmployeeRetrieve.EmployeeRetrieve.role_id.id,
          "ioasioaido",
          data.role,
          IDs
        );

        SetRole_id(state.EmployeeRetrieve.EmployeeRetrieve.role_id.id);
      }
    }
  }, [state.EmployeeRetrieve.EmployeeRetrieve.id, !displayStatus]);

  const [EmpEdit, setEmpEdit] = useState([
    {
      employee_request: "",
      role_id: "",

      inquiry_id: state.ClientBranchIDs.EmployeeIDs,
    },
  ]);

  const handleAddEmpFields = () => {
    const values = [...EmpEdit];
    values.push({ employee_request: "", role_id: "", inquiry_id: null });
    setEmpEdit([
      {
        employee_request: "",
        role_id: "",
        inquiry_id: null,
      },
    ]);
    setEmpEdit(values);
  };

  const handleRemoveEmpFields = (index) => {
    const values = [...EmpEdit];
    values.splice(index, 1);
    setEmpEdit(values);
  };

  const handleInputEDItChange = (index, event) => {
    const values = [...EmpEdit];
    if (event.target.name === "employee_request") {
      values[index].employee_request = event.target.value;
    }
    //  else {
    //   values[index].role = event.target.value;
    // }

    setInputFields(values);
  };

  const handleRoleEdit = (selectedVal, index) => {
    // setRoleSel(selectedVal);
    // SetMuliEditrole(selectedVal);
    // setData({
    //   ...data,
    //   role: selectedVal.value,
    // });
    if (index != 0) {
      SetMuliEditrole(selectedVal);
      setRoleSel(selectedVal);
      const values = [...EmpEdit];
      values[index].role_id = selectedVal.value;
      console.log(EmpEdit, "empkkkkk");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // handle form submission here
    alert(JSON.stringify(inputFields, null, 2));
  };

  const HandleEdit = () => {
    console.log(EmpEdit, "dafsf234", state.ClientBranchIDs.ClientBranchID);
    if (
      // state.ClientBranchIDs.EmployeeIDs != undefined ||
      displayStatus &&
      state.ClientBranchIDs.ClientBranchID != ""
    ) {
      var a = 0;
      if (EmpEdit[0].employee_request == "") {
        setEmpErr("*employee is required");
        a = 1;
      }

      if (a == 0) {
        console.log(data, "datas", EditId);
        const payloads = {
          datas: EmpEdit,
          EditId: state.ClientBranchIDs.EmployeeIDs,
          currentPage: currentPage,
          client_id: state.ClientBranchIDs.ClientBranchID,
        };
        dispatch(SetEmployeeEditcallActions(payloads));
      }
    }
  };

  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  ///-------Employee----Mulitiple =--Create----Selects------------------------------

  const HandleClick = () => {
    console.log(inputFields, "opopopop");
    console.log(JSON.stringify(inputFields), "dsdszd");
    if (!displayStatus) {
      var a = 0;
      if (inputFields.employee_request == "") {
        setEmpErr("*employee is required");
        a = 1;
      }

      if (inputFields.role_id == "") {
        setroleError("*role is required");
        a = 1;
      }
      if (a == 0) {
        console.log(data, "datas");

        const payloads = {
          // datas: data,
          inputFields: inputFields,
          inputFieldstest: JSON.stringify(inputFields),
          client_id: state.ClientBranchIDs.ClientBranchID,
          // client_id: state.ClientBranchIDs.EmployeeIDs
        };
        dispatch(SetEmployeeActions(payloads));

        dispatch(getEMployeeInquriyIDS(""));
        // dispatch(getClientEditActions(true));
      }
    }
  };

  useEffect(() => {
    console.log(state.ClientBranchIDs.EmployeeIDs, "test");
    if (state.ClientBranchIDs.EmployeeIDs == "") {
      console.log("yes", state.ClientBranchIDs.EmployeeIDs);
      setDisplayStatus(false);
      console.log(state.ClientBranchIDs.EmployeeIDs, "ifds");
    } else {
      console.log("NO", state.ClientBranchIDs.EmployeeIDs);
      setDisplayStatus(true);
      console.log(EmpEdit, "emplist");
    }
  }, []);
  return (
    <>
      <div className="Employee">
        <div className={stateDisplay ? " POPUP" : "outerPOPUP"}>
          <div className="EmployeePopup">
            <div className="InnerEmployee">
              <div className="BeforeEMpPopUp">
                <div className=" BodyEmployeeContent">
                  <div className="card FormParts">
                    <div className="card-body cards ">
                      <div className="UserPoup">
                        <div className="BeforForms">
                          <div className="Form">
                            <div className="ModalHeader">
                              <div>
                                {!displayStatus ? (
                                  <span>Employee Create </span>
                                ) : (
                                  <span>Employee Edit</span>
                                )}
                              </div>
                            </div>

                            <div className="Modal-Body">
                              {!displayStatus ? (
                                <form onSubmit={handleSubmit}>
                                  <div className="form-row">
                                    {inputFields.map((inputField, index) => (
                                      <Fragment key={`${inputField}~${index}`}>
                                        <div className="form-group col-sm-4">
                                          {/* <div className='col-12 mt-3'> */}
                                          <label
                                            for="validationCustom01"
                                            class="form-label"
                                          >
                                            Role
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </label>
                                          <Select
                                            className="Selects"
                                            styles={{
                                              position: "relative",
                                              top: "60px",
                                            }}
                                            name="role_id"
                                            // options={options}
                                            // onChange={handleChange}
                                            onSelect={(e) => setMuliselect(e)}
                                            onChange={(e) => {
                                              handleSelectChange(e, index);
                                              setroleError("");
                                            }}
                                            options={nameList}
                                            labelledBy="Select"
                                          />
                                          <p className="Error">{roleError}</p>

                                          {/* </div> */}
                                        </div>

                                        <div
                                          className="form-group col-sm-4"
                                          style={{ marginTop: "7px" }}
                                        >
                                          <employee_requestlabel htmlFor="employee_request">
                                            Employee Request
                                            <span style={{ color: "red" }}>
                                              *
                                            </span>
                                          </employee_requestlabel>
                                          <input
                                            type="number"
                                            className="form-control"
                                            id="employee_request"
                                            name="employee_request"
                                            value={inputField.employee_request}
                                            onChange={(event) =>
                                              handleInputChange(index, event)
                                            }
                                          />
                                        </div>

                                        <div className="form-group col-sm-2">
                                          <button
                                            className="btn btn-link"
                                            type="button"
                                            disabled={index === 0}
                                            onClick={() =>
                                              handleRemoveFields(index)
                                            }
                                          >
                                            -
                                          </button>
                                          <button
                                            className="btn btn-link"
                                            type="button"
                                            onClick={() => handleAddFields()}
                                          >
                                            +
                                          </button>
                                        </div>
                                      </Fragment>
                                    ))}
                                  </div>

                                  {/* <br />
                                  <pre>{JSON.stringify(inputFields)}</pre> */}
                                </form>
                              ) : (
                                <>
                                  <form onSubmit={handleSubmit}>
                                    <div className="form-row">
                                      {EmpEdit.map((inputField, index) => (
                                        <Fragment
                                          key={`${inputField}~${index}`}
                                        >
                                          <div className="form-group col-sm-4">
                                            <label
                                              for="validationCustom01"
                                              class="form-label"
                                            >
                                              Role
                                            </label>
                                            <Select
                                              className="Selects"
                                              styles={{
                                                position: "relative",
                                                top: "60px",
                                              }}
                                              // options={options}
                                              // onChange={handleChange}
                                              onSelect={(e) =>
                                                SetMuliEditrole(e)
                                              }
                                              onChange={(e) => {
                                                handleRoleEdit(e, index);
                                                SetRoleEdiErr("");
                                              }}
                                              // options={[{"value":"3456789","label":"IT"}]}
                                              labelledBy="Select"
                                              // value={"3456789"}
                                              //  options={nameList}
                                              // value={inputField.inquiry_id}
                                              // value={index==0?Selectrole:MuilEditROle}
                                              name="role_id"
                                            />
                                            <p className="Error">{RoleErrE}</p>

                                            {/* </div> */}
                                          </div>

                                          <div className="form-group col-sm-6">
                                            <label htmlFor="employee">
                                              Employee Request
                                            </label>
                                            <input
                                              type="number"
                                              className="form-control"
                                              // id="employee"
                                              // name="employee"
                                              // //value={EmpEdit.employee}
                                              // onChange={(event) =>
                                              //   handleInputEDItChange(index, event)
                                              // }
                                              value={
                                                inputField.employee_request
                                              }
                                              name="employee_request"
                                              //value={EmpEdit.employee_request}
                                              //  value={data.employee}
                                              onChange={(event) =>
                                                handleInputEDItChange(
                                                  index,
                                                  event
                                                )
                                              }
                                            />
                                          </div>
                                          {EmpEdit.employee_request}

                                          <div className="form-group col-sm-2">
                                            <button
                                              className="btn btn-link"
                                              type="button"
                                              disabled={index === 0}
                                              onClick={() =>
                                                handleRemoveEmpFields(index)
                                              }
                                            >
                                              -
                                            </button>
                                            <button
                                              className="btn btn-link"
                                              type="button"
                                              onClick={() =>
                                                handleAddEmpFields()
                                              }
                                            >
                                              +
                                            </button>
                                          </div>
                                        </Fragment>
                                      ))}
                                    </div>

                                    {/* <br /> */}
                                    {/* <pre> */}
                                    {/* {JSON.stringify(EmpEdit, null, 2)} */}
                                    {/* </pre> */}
                                  </form>
                                </>
                              )}
                              <div className="UserButtons">
                                <button
                                  class="btn  SaveBtn"
                                  type="submit"
                                  onClick={(e) => {
                                    HandleClick(e);
                                    HandleEdit(e);
                                  }}
                                >
                                  Submit
                                </button>

                                <button
                                  class="btn CancelBtn"
                                  onClick={(e) => {
                                    // setShow(false);
                                    window.location.href = "/clientDetails";
                                  }}
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeCreate;
